// extracted by mini-css-extract-plugin
module.exports = {"type_icon":"styles__type_icon--_N-6P"};